import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Auth from '../Authentication/Auth';
import Api from '../../Services/Api';


import FuelTankOverview from '../FuelTanks/FuelTankOverview';

class FuelTruckList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fuelTrucks: [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.fuelTrucks) {
      this.setState({ fuelTrucks: nextProps.fuelTrucks });
    }
  }

  renderNoFuelTanks() {
    return (
      <section className="page-content-items">
        No Fuel Trucks. Please add one to get started.
      </section>
    );
  }

  renderFuelTanks() {

    return (this.state.fuelTrucks.map((fuelTruck, i) =>
      <FuelTankOverview key={fuelTruck.id} fuelTank={fuelTruck.fuelTanks[0]} fboId={this.props.fboId} ownerName={fuelTruck.name} ownerId={fuelTruck.id} ownerType="fueltruck" />)
    );
  }

  renderFuelTanksx() {
    return (
      this.state.fuelTanks.map((fuelTank, i) =>
        <FuelTankOverview key={fuelTank.id} fuelTank={fuelTank} fboId={this.props.fboId} ownerId={this.props.ownerId} ownerType={this.props.ownerType} />)
    );
  }

  render() {
    return (
      <section className="fuel-item-list">
        {this.state.fuelTrucks.length > 0 ? (
          this.renderFuelTanks()
        ) : (
          this.renderNoFuelTanks()
        )}
      </section>
    );
  }
}

FuelTruckList.propTypes = {
  fboId: PropTypes.number.isRequired,
  fuelTrucks: PropTypes.any,
};

FuelTruckList.defaultProps = {
  fuelTrucks: [],
};

export default FuelTruckList;



// WEBPACK FOOTER //
// ./src/Containers/FuelTrucks/FuelTruckList.js